<div class="card mt-2">
  <div class="card-header px-2 py-1 d-flex flex-row">
    <div class=" form-inline flex-grow-1">
      <strong class="py-2">
        {{curArea?.displayName}} ({{curArea?.name}}) Summary
      </strong>
    </div>
    <div class="flex-shrink-1">
      <button type="button" class="btn btn-sm" (click)="isDebugRowsVisible = !isDebugRowsVisible"
        [ngClass]="isDebugRowsVisible ? 'btn-info' : 'btn-light'"
        title="Show additional data rows used in calculations.">
        <i class="fas fa-bug"></i>
      </button>
    </div>
  </div>
  <div class="card-body p-2" style="overflow-x:auto">
    <table class="table table-sm table-striped small">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let p of periodSettings.periods" style="text-align: left;">{{p.label}}</th>
          <th style="text-align: right;">Total</th>
        </tr>
      </thead>
      <tbody *ngIf="curArea">

        <tr (click)="toggle('totalUnits')"  style="cursor: pointer;" [style.font-weight]="isExpanded('totalUnits') ? 'bold' : 'normal'">
          <td>
            <i>
              Total Units
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.unitCount || 0}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('totalUnits') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.unitCount || 0}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('Occupancy')"  style="cursor: pointer;" [style.font-weight]="isExpanded('Occupancy') ? 'bold' : 'normal'">
          <td>
            <i>
              Occupancy
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estOccPct | percent: '0.1-1'}}
          </td>
        </tr>

        <ng-container *ngFor="let unitType of unitTypes; let index = index">
          <tr *ngIf="isExpanded('Occupancy') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>

            <td *ngFor="let a of unitType.periods; let index = index" style="text-align: left; color: #a18f6c; font-weight: bold;">
              <span *ngIf="index >= cyJanPeriodIndex">
                <input type="text" 
                        #thisInput="ngModel" 
                        class="text-right input-subtle" 
                        style="margin-right:8px; width:3.5rem; color: green"                        
                        [ngModel]="unitType.periods[index].estOccPct | percent: '0.1-1'"
                        (ngModelChange)="thisInput.valid ? updateOccEstimate(unitType.revAreaId, index, $event) : undefined"
                        (blur)="updateOccEstimateForce(unitType.revAreaId, index)"
                        pattern="^\s*(\+|-)?((\d{1,3},?)+(\.\d*)?|\.\d+)\s*%?\s*$"
                        [ngClass]="{'is-invalid': thisInput.invalid, 'bg-light': !thisInput.invalid }" tccSelectOnFocus
                        [id]="'estOccPct-' + index + '-' + unitType.revAreaId"
                        value="13" /> 
                <span style="font-weight: normal; font-size:x-small;">({{(unitType!.summary!.unitCount! * unitType!.periods[index]!.estOccPct!) | number: '0.0-0'}} / {{unitType.summary!.unitCount}})</span>
              </span>
              <span *ngIf="index < cyJanPeriodIndex">
                {{a.estOccPct || 0 | percent: '0.1-1'}}
              </span>              
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('GoodNewLeases')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GoodNewLeases') ? 'bold' : 'normal'">
          <td>
            <i>
              *Good New Leases
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estNewLeases || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GoodNewLeases') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estNewLeases || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('GoalRenewalLeases')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GoalRenewalLeases') ? 'bold' : 'normal'">
          <td>
            <i>
              *Goal Renewal Leases
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estRenewalLeases || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GoalRenewalLeases') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estRenewalLeases || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('OriginalLeaseCount')"  style="cursor: pointer;" [style.font-weight]="isExpanded('OriginalLeaseCount') ? 'bold' : 'normal'">
          <td>
            <i>
              *Original Lease Count
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.origLeaseCount || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('OriginalLeaseCount') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.origLeaseCount || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('EarlyExpirationCount')"  style="cursor: pointer;" [style.font-weight]="isExpanded('EarlyExpirationCount') ? 'bold' : 'normal'">
          <td>
            <i>
              *Early Expiration Count
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcOrigEarlyExpiryCnt || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('EarlyExpirationCount') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcOrigEarlyExpiryCnt || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('RevisedOriginalLeaseCount')"  style="cursor: pointer;" [style.font-weight]="isExpanded('RevisedOriginalLeaseCount') ? 'bold' : 'normal'">
          <td>
            <i>
              *Revised Original Lease Count
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcOrigRevisedLeaseCnt || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('RevisedOriginalLeaseCount') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcOrigRevisedLeaseCnt || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>


        <tr *ngIf="isDebugRowsVisible" (click)="toggle('PeriodCreatedLeases')"  style="cursor: pointer;" [style.font-weight]="isExpanded('PeriodCreatedLeases') ? 'bold' : 'normal'">
          <td>
            <i>
              *Period Created Leases
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcLeaseCntDelta || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('PeriodCreatedLeases') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcLeaseCntDelta || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('OriginalRevenue')"  style="cursor: pointer;" [style.font-weight]="isExpanded('OriginalRevenue') ? 'bold' : 'normal'">
          <td>
            <i>
              *Original Revenue
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.origTotalRevenue || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('OriginalRevenue') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.origTotalRevenue || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('RevisedOriginalRevenue')"  style="cursor: pointer;" [style.font-weight]="isExpanded('RevisedOriginalRevenue') ? 'bold' : 'normal'">
          <td>
            <i>
              *Revised Original Revenue
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcOrigRevisedRevenue || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('RevisedOriginalRevenue') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcOrigRevisedRevenue || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="isDebugRowsVisible" (click)="toggle('GrowthRateRevenueAmt')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GrowthRateRevenueAmt') ? 'bold' : 'normal'">
          <td>
            <i>
              *Growth Rate Revenue Amt
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcGrowthRateRevenue || 0 | number: '1.2-2'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GrowthRateRevenueAmt') && isDebugRowsVisible && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcGrowthRateRevenue || 0 | number: '1.2-2'}}
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="curArea?.areaType !== 'Self'" (click)="toggle('BaseFpRate')"  style="cursor: pointer;" [style.font-weight]="isExpanded('BaseFpRate') ? 'bold' : 'normal'">
          <td>
            <i>
              Base FP Rate
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estBaseFpRate | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('BaseFpRate') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estBaseFpRate || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="amenities">
          <ng-container *ngFor="let amenity of amenities">
            <tr (click)="toggle(toCamelCase(amenity.name))"  style="cursor: pointer;" [style.font-weight]="isExpanded(toCamelCase(amenity.name)) ? 'bold' : 'normal'">
              <td>
                <i>
                  {{amenity.name.split('~~')[0]}}
                  <span *ngIf="amenity.name.split('~~')[1]"
                    class="d-inline-block ml-1 small bg-warning text-dark rounded px-1 font-weight-bold">
                    {{amenity.name.split('~~')[1]}}
                  </span>
                </i>
              <td *ngFor="let a of amenity.periods;" style="text-align: left;">
                {{a.estNewRate| number: '0.0-0'}}
              </td>
            </tr>
            <ng-container *ngFor="let unitType of unitTypes">
              <tr *ngIf="isExpanded(toCamelCase(amenity.name)) && isDetailVisible(unitType)">
                <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
                <td *ngFor="let a of amenity.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
                  {{a.estNewRate || 0 | number: '0.0-0'}}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <tr (click)="toggle('FpRate')"  style="cursor: pointer;" [style.font-weight]="isExpanded('FpRate') ? 'bold' : 'normal'">
          <td>
            <i>
              FP Rate
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estNewRate | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('FpRate') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estNewRate || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('FinalAverageRent')"  style="cursor: pointer;" [style.font-weight]="isExpanded('FinalAverageRent') ? 'bold' : 'normal'">
          <td>
            <i>
              Final Ave Rent
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcAvgRate | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('FinalAverageRent') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcAvgRate || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('ProjectedRateGrowth')"  style="cursor: pointer;" [style.font-weight]="isExpanded('ProjectedRateGrowth') ? 'bold' : 'normal'">
          <td>
            <i>
              Projected Rate Growth %
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estRateGrowth | percent: '0.1-1'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('ProjectedRateGrowth') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estRateGrowth || 0 | percent: '0.1-1'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('RevenueWODelinquencies')"  style="cursor: pointer;" [style.font-weight]="isExpanded('RevenueWODelinquencies') ? 'bold' : 'normal'">
          <td>
            <i>
              Rent Revenue (w/o delinquencies)
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.calcTotalRevenue | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('RevenueWODelinquencies') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.calcTotalRevenue || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('PYRentRevenue')"  style="cursor: pointer;" [style.font-weight]="isExpanded('PYRentRevenue') ? 'bold' : 'normal'">
          <td>
            <i>
              {{periodSettings.py}} Rent Revenue
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.pyRevenue | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('PYRentRevenue') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.pyRevenue || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('ProjectedRevenueGrowth')"  style="cursor: pointer;" [style.font-weight]="isExpanded('ProjectedRevenueGrowth') ? 'bold' : 'normal'">
          <td>
            <i>
              Projected Revenue Growth %
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estRevenueGrowth | percent: '0.1-1'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('ProjectedRevenueGrowth') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estRevenueGrowth || 0 | percent: '0.1-1'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('GPR')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GPR') ? 'bold' : 'normal'">
          <td>
            <i>
              GPR
            </i>
            <ng-container *ngIf="(comments$ | async) as comments">
              <a *ngIf="comments['gpr']?.hasComments" (click)="showComment('gpr')">
                <i class="fas fa-comment"></i>
              </a>
            </ng-container>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estGpr | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GPR') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estGpr || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('GPRActBud')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GPRActBud') ? 'bold' : 'normal'">
          <td>
            <i>
              {{periodSettings.py}} GPR Act/Bud
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.pyGpr | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GPRActBud') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.pyGpr || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>


        <tr (click)="toggle('VacancyLoss')"  style="cursor: pointer;" [style.font-weight]="isExpanded('VacancyLoss') ? 'bold' : 'normal'">
          <td>
            <i>
              Vacancy Loss
            </i>
            <ng-container *ngIf="(comments$ | async) as comments">
              <a *ngIf="comments['vacancyLoss']?.hasComments" (click)="showComment('vacancyLoss')">
                <i class="fas fa-comment"></i>
              </a>
            </ng-container>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estVacancyLoss | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('VacancyLoss') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estVacancyLoss || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('VacancyLossActBud')"  style="cursor: pointer;" [style.font-weight]="isExpanded('VacancyLossActBud') ? 'bold' : 'normal'">
          <td>
            <i>
              {{periodSettings.py}} Vacancy Loss Act/Bud
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.pyVacancyLoss | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('VacancyLossActBud') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.pyVacancyLoss || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('GainLossLease')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GainLossLease') ? 'bold' : 'normal'">
          <td>
            <i>
              Gain (Loss)/Lease
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.estGainLoss | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GainLossLease') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.estGainLoss || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

        <tr (click)="toggle('GainLossLeaseActBud')"  style="cursor: pointer;" [style.font-weight]="isExpanded('GainLossLeaseActBud') ? 'bold' : 'normal'">
          <td>
            <i>
              {{periodSettings.py}} Gain (Loss)/Lease Act/Bud
            </i>
          <td *ngFor="let a of curArea.periods;" style="text-align: left;">
            {{a.pyGainLoss | number: '0.0-0'}}
          </td>
        </tr>
        <ng-container *ngFor="let unitType of unitTypes">
          <tr *ngIf="isExpanded('GainLossLeaseActBud') && isDetailVisible(unitType)">
            <td style="padding-left: 20px; color: #a18f6c; font-weight: bold;">{{unitType.name}}</td>
            <td *ngFor="let a of unitType.periods;" style="text-align: left; color: #a18f6c; font-weight: bold;">
              {{a.pyGainLoss || 0 | number: '0.0-0'}}
            </td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>
</div>
